<template>
  <div>
    <div class="flex flex-col p-4 items-center">
      <div class="w-full flex flex-col">
        <!-- 🔹 Contenedor de Tabs -->
        <div
          class="w-full bg-[#f7fafd] flex rounded-md p-1 shadow-sm bg-gray-200"
        >
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="activeTab = tab.id"
            class="flex-1 text-center py-2.5 text-md font-medium rounded-md transition-all duration-200"
            :class="{
              'bg-white text-gray-900 font-semibold shadow-sm':
                activeTab === tab.id,
              'text-gray-500 hover:text-gray-700 bg-gray-200':
                activeTab !== tab.id,
            }"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- 🔸 Contenido del Tab Activo -->
        <div class="p-4" v-if="reportData.monthsIncomes.length > 0">
          <div v-if="activeTab === 'summary' || isPrintMode">
            <Summary
              :widthChart="widthChart"
              :monthsIncomes="reportData.monthsIncomes"
              :monthsExpenses="reportData.monthsExpenses"
            />
          </div>
          <div v-if="activeTab === 'income' || isPrintMode">
            <Income
              :monthsIncomes="reportData.monthsIncomes"
              :widthChart="widthChart"
              :monthsSalesServices="reportData.monthsSalesServices"
              :monthsSalesProducts="reportData.monthsSalesProducts"
              :topProductsSales="reportData.topProductsSales"
            />
          </div>
          <div v-if="activeTab === 'expenses' || isPrintMode">
            <Expenses
              :monthsExpensesDynamics="reportData.monthsExpensesDynamics"
              :monthsExpensesProducts="reportData.monthsExpensesProducts"
              :monthsExpensesStatics="reportData.monthsExpensesStatics"
            />
          </div>
          <div v-if="activeTab === 'operations' || isPrintMode">
            <Operations
              :isMonthly="isMonthly"
              :weekOrders="reportData.weekOrders"
              :weekAverageTimeOrders="reportData.weekAverageTimeOrders"
            />
          </div>
          <div v-if="activeTab === 'profitability' || isPrintMode">
            <Profitability
              :profitabilityMonths="reportData.profitability"
              :widthChart="widthChart"
            />
          </div>
          <div v-if="activeTab === 'statistics' || isPrintMode">
            <Statistics
              :topClients="reportData.topClients"
              :technicalPerformance="reportData.technicalPerformance"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";

import Summary from "./Summary.vue";
import Profitability from "./Profitability.vue";
import Statistics from "./Statistics.vue";
import Income from "./Income.vue";
import Expenses from "./Expenses.vue";
import Operations from "./Operations.vue";

export default {
  name: "FinancesIndex",
  components: {
    Summary,
    Profitability,
    Statistics,
    Income,
    Expenses,
    Operations,
  },
  props: {
    widthChart: {
      type: Number,
      default: 600,
    },
    isPrintMode: {
      type: Boolean,
      default: false,
    },
    isMonthly: {
      type: Boolean,
      default: true,
    },
    reportData: {
      type: Object,
      required: true,
      default: () => ({
        totalSales: 0,
        averageTicket: 0,
        totalOrdersCompleted: 0,
        averageTimeFromTicket: 0,
        monthsIncomes: [],
        monthsExpensesProducts: [],
        monthsExpensesStatics: [],
        monthsExpensesDynamics: [],
        profitability: [],
        weekOrders: [],
        weekAverageTimeOrders: [],
        monthsSalesServices: [],
        monthsSalesProducts: [],
        topProductsSales: [],
        topClients: [],
      }),
    },
  },
  data() {
    return {
      customRange: [],
      activeTab: "summary",
      tabs: [
        { id: "summary", label: "Resumen General" },
        { id: "income", label: "Ingresos" },
        { id: "expenses", label: "Gastos" },
        { id: "operations", label: "Operaciones" },
        { id: "profitability", label: "Rentabilidad" },
        { id: "statistics", label: "Estadísticas" },
      ],
    };
  },
  computed: {},
  methods: {
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
button {
  min-width: 100px;
}

/* Efecto suave al pasar el mouse */
button:hover {
  transform: translateY(-1px);
}
</style>
